module.exports = __webpack_public_path__ + "static/media/instagram_dark.3493e68c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instagram_dark.svg
// module id = 2424
// module chunks = 7